import { render, staticRenderFns } from "./profile-tick.vue?vue&type=template&id=588388f1&"
import script from "./profile-tick.vue?vue&type=script&lang=js&"
export * from "./profile-tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588388f1')) {
      api.createRecord('588388f1', component.options)
    } else {
      api.reload('588388f1', component.options)
    }
    module.hot.accept("./profile-tick.vue?vue&type=template&id=588388f1&", function () {
      api.rerender('588388f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/profile-tick.vue"
export default component.exports